import * as React from 'react'

const ArrowRightIcon = (props) => (
  <svg width={17} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.04 11.537a.5.5 0 0 1 0-.707l4.147-4.147H1.394a.5.5 0 0 1 0-1h13.793L11.04 1.537a.5.5 0 1 1 .707-.707l5 5a.5.5 0 0 1 0 .707l-5 5a.5.5 0 0 1-.707 0Z"
      fill="#fff"
    />
  </svg>
)

export default ArrowRightIcon
